module.exports = __webpack_public_path__ + "img/lg_ring_g_l_0_1@3x.e111f041.png";